import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import EndUserShell, { card, inputStyle, btnStyle } from './EndUserShell';

export default function EndUserLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    const res = await login(username.trim(), password);
    setBusy(false);
    if (res.success) navigate('/app');
    else setErr(res.error || 'Napaka pri prijavi');
  };

  return (
    <EndUserShell title="Prijava">
      <div style={card}>
        <form onSubmit={submit}>
          <input style={inputStyle} value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Uporabniško ime" autoCapitalize="none" autoCorrect="off" />
          <input style={inputStyle} type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Geslo" />
          {err && <div style={{ color: '#c00', marginBottom: 10, fontSize: 14 }}>{err}</div>}
          <button style={btnStyle} disabled={busy}>{busy ? '…' : 'Prijava'}</button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 14, fontSize: 13, color: '#666' }}>
          Za dostop nas kontaktiraj: <a href="mailto:info@avtoradar.com">info@avtoradar.com</a>
        </p>
      </div>
    </EndUserShell>
  );
}
